
export const validateBinScan = (currentBin, scannedBin, setError, setShowError) => {
  if (!currentBin || currentBin.name !== scannedBin) {
    setError("Please scan a bin first");
    setShowError(true);
    return false;
  }
  return true;
};


export const findSerializedItemMatch = (rows, itemCode) => {
  console.log("sdfghgfddfgfbvvvvv",rows,itemCode)
  const rowsWithSerialNumbers = rows.filter(row => 
    row.serial_numbers?.length > 0
  );
  console.log("2345666666666665555",rowsWithSerialNumbers);
  console.log("2345666666666665555 33333",rowsWithSerialNumbers.find(row => 
    row.serial_numbers.includes(itemCode)
  ));
  return rowsWithSerialNumbers.find(row => 
    row.serial_numbers.includes(itemCode)
  );
};


export const isItemFullyDistributed = (itemRows) => {
  const originalQty = itemRows[0]?.received_qty || 0;
  const totalScanned = itemRows.reduce((sum, row) => sum + row.scan_qty, 0);
  return totalScanned >= originalQty;
};


export const findExistingRowForSerialItem = (rows, itemCode, currentBin) => {
  return rows.findIndex(row => 
    row.new_bin === currentBin && 
    row.scan_qty < row.grn_qty && 
    row.serial_numbers?.includes(itemCode)
  );
};


export const findUndistributedSerialRow = (rows, itemCode) => {
  return rows.findIndex(row => 
    !row.new_bin && 
    row.scan_qty < row.grn_qty && 
    row.serial_numbers?.includes(itemCode)
  );
};


export const findExistingRowForItem = (rows, itemCode, currentBin) => {
  return rows.findIndex(row =>
    row.item_code.toLowerCase() === itemCode.toLowerCase() &&
    row.new_bin === currentBin &&
    row.scan_qty < row.grn_qty
  );
};


export const findUndistributedItemRow = (rows, itemCode) => {
  return rows.findIndex(row =>
    row.item_code.toLowerCase() === itemCode.toLowerCase() &&
    !row.new_bin &&
    row.scan_qty < row.grn_qty
  );
};


export const updateExistingSerialRow = (rows, rowIndex, itemCode, setCurrentSelectRow,serialno) => {
  const updatedRows = [...rows];
  updatedRows[rowIndex] = {
    ...updatedRows[rowIndex],
    serial_no_used:[...updatedRows[rowIndex]?.serial_no_used,serialno],
    scan_qty: updatedRows[rowIndex].scan_qty + 1,
    amount: updatedRows[rowIndex].rate * (updatedRows[rowIndex].scan_qty + 1)
  };

  updateRemainingQuantities(updatedRows, rowIndex, itemCode);
  setCurrentSelectRow(updatedRows[rowIndex]);
  return updatedRows;
};


export const createNewDistributionForSerialItem = (rows, rowIndex, itemCode, currentBin, setCurrentSelectRow,serialno) => {
  const updatedRows = [...rows];
  updatedRows[rowIndex] = {
    ...updatedRows[rowIndex],
    serial_no_used:[...updatedRows[rowIndex]?.serial_no_used,serialno],
    scan_qty: updatedRows[rowIndex].scan_qty + 1,
    new_bin: currentBin,
    amount: updatedRows[rowIndex].rate * (updatedRows[rowIndex].scan_qty + 1)
  };

  updateRemainingQuantities(updatedRows, rowIndex, itemCode);
  setCurrentSelectRow(updatedRows[rowIndex]);
  return updatedRows;
};


export const updateExistingItemRow = (rows, rowIndex, itemCode, setCurrentSelectRow) => {
  const updatedRows = [...rows];
  updatedRows[rowIndex] = {
    ...updatedRows[rowIndex],
    scan_qty: updatedRows[rowIndex].scan_qty + 1,
    amount: updatedRows[rowIndex].rate * (updatedRows[rowIndex].scan_qty + 1)
  };

  updateRemainingQuantities(updatedRows, rowIndex, itemCode);
  setCurrentSelectRow(updatedRows[rowIndex]);
  return updatedRows;
};


export const createNewDistributionForItem = (rows, rowIndex, itemCode, currentBin, setCurrentSelectRow) => {
  const updatedRows = [...rows];
  updatedRows[rowIndex] = {
    ...updatedRows[rowIndex],
    scan_qty: updatedRows[rowIndex].scan_qty + 1,
    new_bin: currentBin,
    amount: updatedRows[rowIndex].rate * (updatedRows[rowIndex].scan_qty + 1)
  };

  updateRemainingQuantities(updatedRows, rowIndex, itemCode);
  setCurrentSelectRow(updatedRows[rowIndex]);
  return updatedRows;
};


export const updateRemainingQuantities = (rows, startIndex, itemCode) => {
  const originalQty = rows[startIndex].received_qty;
  const totalScanned = rows
    .filter(row => row.item_code === itemCode)
    .reduce((sum, row) => sum + row.scan_qty, 0);
    
  const newRemainingQty = originalQty - totalScanned;
  let remainingToAllocate = newRemainingQty;

  for (let i = startIndex + 1; i < rows.length; i++) {
    if (
      rows[i].item_code.toLowerCase() === itemCode.toLowerCase() &&
      !rows[i].serial_numbers?.length
    ) {
      rows[i] = {
        ...rows[i],
        grn_qty: remainingToAllocate - rows[i].scan_qty
      };
      remainingToAllocate -= rows[i].scan_qty;
    }
  }
};


export const getSerialItemsForCode = (rows, itemCode) => {
  return rows.filter(row => 
    row.serial_numbers?.length > 0 && 
    row.item_code === itemCode
  );
};


export const getNonSerialItemsForCode = (rows, itemCode) => {
  return rows.filter(row => 
    row.item_code.toLowerCase() === itemCode.toLowerCase() &&
    (!row.serial_numbers || row.serial_numbers.length === 0)
  );
};